import { h } from "preact";

import { JiraAttachmentDetails } from "../../../foundation/model/JiraAttachment";
import classname from "../../../foundation/utils/classname";
import IconJira from "../Icons/IconJira";

import JiraAttachmentLink from "./JiraAttachmentLink";
import JiraStatusTag from "./JiraStatusTag";

import styles from "./JiraAttachmentItem.module.css";

type Props = {
    issueKey: string;
    details?: JiraAttachmentDetails;
    href: string | undefined;
    class?: string;
    iconClass?: string;
    linkClass?: string;
    showIcon?: boolean;
    onClick?: (openInJira?: boolean) => void;
};

function JiraAttachmentItem({
    issueKey, details, href, class: cssClass, iconClass, linkClass, showIcon = true, onClick
}: Props) {
    return (
        <div class={classname(styles.jiraAttachmentItem, cssClass)}>
            {showIcon && (
                <span class={styles.jiraLogo}>
                    <IconJira class={iconClass}/>
                </span>
            )}
            <JiraAttachmentLink
                class={classname(styles.jiraAttachmentLink, linkClass, "ellipsis")}
                issueKey={issueKey}
                details={details}
                href={href}
                onClick={onClick}/>
            {details && (
                <JiraStatusTag class={styles.jiraStatusTag} status={details.status}/>
            )}
        </div>
    );
}

export default JiraAttachmentItem;
